import * as React from "react";

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Container from '@mui/material/Container';

import KitchenOrders from "./KitchenOrders.jsx";
import KitchenComplete from "./KitchenComplete.jsx";

const ORDER_INDEX = 0;
const COMPLETE_INDEX = 1;

// interface for kitchen staff
// manages which tab the user is on
export default function KitchenStaff() {

  //manages the state of the tabs, what tab is currently selected
  const [index, setIndex] = React.useState(ORDER_INDEX);

  //Handle tab change
  const handleChange = (event, newIndex) => {
    //change the index to display different content
    setIndex(newIndex);   
  };  

  return (
    <Container>
        <Tabs value = {index} textColor="inherit" onChange={handleChange} centered TabIndicatorProps={{
          style: {
            backgroundColor: "black",
          }
        }}>
          <Tab label="Orders" sx={{width: 150, fontSize: "1rem", color: "black"}}/>
          <Tab label="Completed" sx={{width: 150, fontSize: "1rem", color: "black"}}/>
        </Tabs>
        <div hidden={ORDER_INDEX !== index}>
          <KitchenOrders></KitchenOrders>
        </div>
        <div hidden={COMPLETE_INDEX !== index}>
          <KitchenComplete></KitchenComplete>
        </div>
    </Container>
  );
};